/**
 * Description:
 * Author: sunc
 * Date: 2019-06-27
 * Time: 17:26
 */
import axios from 'axios'
import '@/assets/js/public/UrlConfig'

// create an axios instance
const localhostBaseURLStr = global.commonLocalhostBaseApiUrl
const baseUrl = global.commonBaseUrl

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? baseUrl : localhostBaseURLStr,
  timeout: 50000,
  headers: {
    'Cache-Control': 'no-cache'
  }
})

export default service
